import React from "react";
import "../Styles/Whyus.css";

const WhyUs = () => {
  return (
    <>

    <div className="why-image">
         <img src="./corporate/WHYUS.png " alt="" />
    </div>

    <div className="whyus-container">

      {/* Hero Section */}
      <div className="whyus-hero">
        <h1>Introducing Swastika Infra Limited</h1>
        <h3>Building Reliable Power Infrastructure</h3>
      </div>

      {/* Intro */}
      <div className="whyus-intro">
        <p>
          At Swastika Infra Limited, we don’t just execute power projects —
          we build reliable infrastructure that strengthens India’s power ecosystem.
          With decades of legacy and 15+ years of EPC expertise, we deliver safe,
          efficient and future-ready electrical solutions.
        </p>
      </div>

      {/* Q&A Section */}
      <div className="whyus-qa">

        <div className="qa-item">
          <h2>Proven EPC Expertise</h2>
          <p>
            Strong track record in distribution & transmission projects including
            underground cabling, substations, rural electrification and smart infrastructure.
          </p>
        </div>

        <div className="qa-item">
          <h2>End-to-End Turnkey Solutions</h2>
          <p>
            Complete EPC services from engineering & design to supply,
            installation, testing and commissioning under one roof.
          </p>
        </div>

        <div className="qa-item">
          <h2>Government & Globally Funded Projects</h2>
          <p>
            Experience in World Bank, PFC, REC and state-funded schemes ensuring
            global standards and transparency.
          </p>
        </div>

        <div className="qa-item">
          <h2>Technical Strength & Skilled Workforce</h2>
          <p>
           Skilled engineers using trenchless methods and modern project management systems.
          </p>
          {/* <p>Experienced engineers leveraging trenchless technologies and advanced project management systems.</p> */}
        </div>

        <div className="qa-item">
          <h2>Quality, Safety & Compliance</h2>
          <p>
            Strict quality control and safety standards ensuring durable
            and reliable infrastructure.
          </p>
        </div>

        <div className="qa-item">
          <h2>Expanding National Presence</h2>
          <p>
            Delivering projects seamlessly across diverse regions of the country, from bustling urban centers to remote and challenging terrains
          </p>
          {/* <p>Delivering impactful projects across diverse regions, driving infrastructure growth nationwide.</p> */}
        </div>

      </div>

    </div>

    </>
  );
};

export default WhyUs;
